<template>
  <a-drawer
    :title="title"
    :width="width"
    placement="right"
    :closable="false"
    @close="close"
    :visible="visible">

    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

        <a-form-item label="批次编码" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['breedBatchCode']" placeholder="请输入批次编码"></a-input>
        </a-form-item>
        <a-form-item :label="$t('label.materialCommonNameFileNo')" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['mmCode']" placeholder="请输入物料通用名档案编号"></a-input>
        </a-form-item>
        <a-form-item :label="$t('label.materialCommonName')" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['mmName']"  :placeholder="$t('label.pleaseEnterTheCommonNameOfTheMaterial')"></a-input>
        </a-form-item>
        <a-form-item :label="$t('label.materialCategory')" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['mmCategory']" placeholder="请输入物料类别"></a-input>
        </a-form-item>
        <a-form-item label="描述" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['mmCategoryName']" placeholder="请输入描述"></a-input>
        </a-form-item>
        <a-form-item :label="$t('label.unitOfMeasurement')" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['unit']" placeholder="请输入计量单位"></a-input>
        </a-form-item>
        <a-form-item :label="$t('label.unitPrice')" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number v-decorator="['price']" :placeholder="$t('label.pleaseEnterTheUnitPrice')"  style="width: 100%"/>
        </a-form-item>
        <a-form-item label="拓展属性" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['costItemCode']" placeholder="请输入拓展属性"></a-input>
        </a-form-item>

      </a-form>
    </a-spin>
    <a-button type="primary" @click="handleOk">{{$t('button.confirm')}}</a-button>
    <a-button type="primary" @click="handleCancel">{{$t('button.cancel')}}</a-button>
  </a-drawer>
</template>

<script>

  import { httpAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'

  export default {
    name: "ViewEfsStlSettleConfirmModal",
    components: {
    },
    data () {
      return {
        form: this.$form.createForm(this),
        title:"操作",
        width:800,
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
        },
        url: {
          add: "/settlePickingList/viewEfsStlSettleConfirm/add",
          edit: "/settlePickingList/viewEfsStlSettleConfirm/edit",
        }
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'breedBatchCode','mmCode','mmName','mmCategory','mmCategoryName','unit','price','costItemCode'))
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }

        })
      },
      handleCancel () {
        this.close()
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'breedBatchCode','mmCode','mmName','mmCategory','mmCategoryName','unit','price','costItemCode'))
      }

    }
  }
</script>

<style lang="less" scoped>
/** Button按钮间距 */
  .ant-btn {
    margin-left: 30px;
    margin-bottom: 30px;
    float: right;
  }
</style>